import { Component, OnInit, Input } from '@angular/core';
import * as echarts from 'echarts';
import { FormsModule, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from "../../services/auth.service";
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HomeService } from '../../services/home.service';
import { AlertComponent } from '../alert/alert.component';
import { InputAlertComponent } from '../input-alert/input-alert.component';
import { CommonEncrypt } from '../../utils/common.encrypt';
import { StudyBase } from '../common/study-base';
import { empty, interval } from 'rxjs';
import { AppendComponent } from '../append/append.component';
import { ModalComponent } from '../modal/modal.component';
import { ActivatedRoute } from "@angular/router"
import { GlobalVariable } from '../../app.globalvariable';
// import E from 'wangeditor'
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})

export class AdminComponent implements OnInit {

  id: string = "";
  idTable: string = "";
  isExitLast: boolean = false;
  isCurrentPage: boolean = false;
  timeLast: string = "";
  isUpdate: boolean = false;
  dataSle: any = {};
  dataTable: any = {};
  // 中心评审

  isSearch: boolean = false;
  pageCurrent: number = 1; // 当前页码
  hospitalName: string = ""; // 医院名称
  status: string = ""; // 状态
  pageTotal: number = 0;

  hospitalItem: string = "";
  inspectTime: string = "";
  userName: string = "";
  mobile: string = "";
  scoreItem: string = '';
  checkStatusItem: string = "";


  checkStatus: string = "001";

  review: any = {};
  scoreMapping = [];
  scoreReview: any = {};

  reviewTemp: any = {};
  scoreMappingTemp: any = {};
  scoreReviewTemp: any = {};
  scoreReviewTableTemp: any = {};

  scoreSum: number = 0;

  score: number = 0;

  info: boolean = false;  //添加信息

  scoreLast: number = 0;  // 上次分数
  dateLast: string = "";  // 上次评估时间

  baseScore: number = 0; // 基本项目分数

  // 图片上传 start.
  isExitTable: boolean = false;
  img1: any = [];
  img2: any = [];
  img3: any = [];
  img4: any = [];
  img5: any = [];
  img6: any = [];
  img7: any = [];
  img8: any = [];
  img9: any = [];
  img10: any = [];
  img11: any = [];
  img12: any = [];
  img13: any = [];
  img14: any = [];
  img15: any = [];
  img16: any = [];
  img17: any = [];
  img18: any = [];
  img19: any = [];
  img20: any = [];
  bigImgSrc: string = "";
  // 图片上传 end.

  specialScore1: number = 0;
  specialScore2: number = 0;
  specialScore3: number = 0;
  specialScore4: number = 0;
  specialScore5: number = 0;
  specialScore6: number = 0;
  specialScore7: number = 0;

  specialScore: number = 0;


  // 建设及服务要求 start . 

  item1Special: number = 0;
  item2Special: number = 0;
  item3Special: number = 0;
  item4Special: number = 0;

  item1SumSpecial: number = 0;
  item2SumSpecial: number = 0;
  item3SumSpecial: number = 0;
  item6_1Special: number = 0;
  item6_2Special: number = 0;
  item6_3Special: number = 0;
  item6_4Special: number = 0;
  item6_5Special: number = 0;
  item6_6Special: number = 0;
  item7Special: number = 0;
  itemSumSpecial: number = 0;

  rate1: any = '';
  rate2: any = '';
  rate3: any = '';
  rate4: any = '';
  rate6_1: any = '';
  rate6_2: any = '';
  rate7: any = '';

  // 建设及服务要求 end . 

  itemSub1: string = "";
  itemSub2: string = "";
  itemSub3: string = "";
  itemSub4: string = "";
  itemSub5: string = "";
  itemSub6: string = "";
  idSub: string = "";

  doctorList: any = [];


  userManagePage: number = 1;
  bsWorkModalRef: BsModalRef;
  bsModalRef: BsModalRef;
  editor: any;
  noticeTitle: string = "";
  noticeContent: any;
  noticeContentReal: any;
  noticeEdit: boolean = false;
  noticeId: string = "";
  showLoading: boolean = false;
  statistic: any;
  newsTitle: string = "";
  newsContent: any;
  newsContentReal: any;
  newsEdit: boolean = false;
  newsId: string = "";
  newsType: string = "";
  newsTypeList: any = [];
  showNotice: boolean = false;
  showNews: boolean = false;
  newsTypeName: string = "";
  noticeList: any;
  newsList: any;
  newsTypeId: string = "";
  currentPage: string = "trends"; // 当前页面，默认为项目动态
  html = ``; //编辑器内容
  public initConfig: any;
  node = 1;

  newsCover: any;
  newsCoverSrc: string = "";
  newsCoverSavePath: string = "";

  image1: File;
  image2: File;
  image3: File;
  image4: File;
  image5: File;
  image6: File;
  image7: File;
  image8: File;
  image9: File;
  image10: File;
  image11: File;
  image12: File;
  image13: File;
  image14: File;
  image15: File;
  image16: File;
  image17: File;
  image18: File;
  image19: File;
  image20: File;

  imgs1: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs2: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs3: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs4: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs5: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs6: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs7: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs8: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs9: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs10: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }



  imgs11: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs12: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs13: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs14: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs15: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs16: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs17: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs18: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs19: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  imgs20: any = {
    number: 1,
    src: "",
    savePath: "",
    status: 1,
  }

  currentPageNews: any = [];
  newsPages: any = [];
  newsCurrentPage: number = 1;
  maxPage: number = 1;


  currentPageNotice: any = [];
  noticePages: any = [];
  noticeCurrentPage: number = 1;

  currentPageStatistic: any = [];
  statisticPages: any = [];
  statisticCurrentPage: number = 1;
  statisticType: number = 1; // 上传

  currentPageUser: any = [];
  userPages: any = [];
  userCurrentPage: number = 1;
  userType: number = 1; // 普通用户

  isAdmin: boolean = false;
  bigImg: boolean = false; // 放大图片


  tableList: any = {};


  constructor(private sanitizer: DomSanitizer, private auth: AuthService,
    public router: Router, public route: ActivatedRoute,
    public service: HomeService,
    public modalService: BsModalService) {

    this.isAdmintor();

    this.getTrends();


    for (let i = 1; i < 61; i++) {
      let item = "item" + i;

      this.review[item] = "";

    }

    for (let j = 1; j < 61; j++) {
      let item = "item" + j;
      let temp = [];

      temp['item'] = item;
      temp['score'] = "";
      temp['mode'] = "";

      this.scoreMapping.push(temp);
    }

    this.scoreInit();
  }

  search() {
    this.isSearch = true;
    this.pageCurrent = 1;
    this.getTableList();
  }

  pageChange(page) {

    let camRequest = true;

    switch (page) {
      case "start":

        if (this.pageCurrent == 1) {
          camRequest = false;
          this.alertItem1("当前已是首页")
        } else {
          this.pageCurrent = 1;
        }

        break;
      case "end":

        if (this.pageCurrent == this.pageTotal) {
          camRequest = false;
          this.alertItem1("当前已是最后一页")
        } else {
          this.pageCurrent = this.pageTotal;
        }

        break;

      case "after":
        if (1 >= this.pageCurrent) {
          camRequest = false;
          this.alertItem1("当前已是首页")
        } else {
          this.pageCurrent--;
        }
        break;

      case "next":
        if (this.pageCurrent >= this.pageTotal) {
          camRequest = false;
          this.alertItem1("当前已是最后一页")
        } else {
          this.pageCurrent--;
        }
        break;
    }

    if (camRequest) {
      this.getTableList();
    }
  }

  scoreInit() {


    // checkbox
    let checkboxItem = ['item12', 'item49', 'item50', 'item51', 'item52', 'item54', 'item55', 'item56'];

    // 单选分数
    // 5分
    let score5 = ['item1', 'item2', 'item5', 'item6', 'item11', 'item24', 'item26', 'item49'];

    // 4分
    let score4 = ['item10', 'item50'];

    // 3分
    let score3 = ['item8', 'item9', 'item51', 'item54'];

    // 2分
    let score2 = ['item12', 'item52', 'item55'];

    // 1分
    let score1 = ['item56'];

    // 10分
    let score10 = ['item25'];

    this.scoreMapping.forEach((value) => {

      if (score5.includes(value['item'])) {
        value['score'] = '5';
        value['mode'] = 'single';
      }

      if (score4.includes(value['item'])) {
        value['score'] = '4';
        value['mode'] = 'single';
      }

      if (score3.includes(value['item'])) {
        value['score'] = '3';
        value['mode'] = 'single';
      }

      if (score2.includes(value['item'])) {
        value['score'] = '2';
        value['mode'] = 'single';
      }

      if (score1.includes(value['item'])) {
        value['score'] = '1';
        value['mode'] = 'single';
      }

      if (score10.includes(value['item'])) {
        value['score'] = '10';
        value['mode'] = 'single';
      }

      if (checkboxItem.includes(value['item'])) {
        value['mode'] = 'checkbox';
      }
    })

    console.log(this.scoreMapping)
  }

  isAdmintor() {

    this.showLoading = true;
    this.service.isAdministrators().subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        if (code == '100000') {
          this.isAdmin = true;
          this.showLoading = false;
        } else {
          this.isAdmin = false;
          this.alertItem(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  editorInit() {

    var that = this;

    // that.editor = new E('#div1')

    console.log(this.editor)

    console.log(111111)


    that.editor.config.customUploadImg = async function (resultFiles, insertImgFn) {

      console.log('222222')

      resultFiles.forEach((file) => {

        that.service.uploadImgForEditor(file).subscribe(
          data => {
            let code = data.resultCode
            let info = data.resultInfo

            console.log(info)
            if (code == '100000') {

              let src = info['src'];
              insertImgFn(src)
            } else {
              that.alertItem1(data.resultMsg);
              document.getElementById('error').style.display = 'block';
            }
          }
        )

      })
    }



    this.editor.config.onchange = function (newHtml) {
      if (that.currentPage == 'notice') {
        that.noticeContentReal = newHtml
      } else if (that.currentPage == 'news') {
        that.newsContentReal = newHtml
      }

    };

    setTimeout(() => {
      this.editor.create()
    }, 200)
  }

  username: string = "";

  ngOnInit(): void {

    this.getTrends();
    this.username = GlobalVariable.getUserName();
  }

  changeOperateUser(type) {

    this.userManagePage = type;

    this.getUserList(this.userCurrentPage)
  }

  operateUser(id, type) {


    let msg = "确定禁用该用户？";

    if (type == 1) {
      msg = "确定恢复该用户？";
    }

    this.banItem1(msg, id, type);

  }

  changePage(page) {

    console.log(page)

    if ((page == 'notice' || page == 'news') && (this.currentPage == 'notice' || this.currentPage == 'news')) {
      this.beforeDestroy();
      this.noticeTitle = "";
      this.noticeContentReal = "";
      this.noticeContent = "";
      this.newsTitle = "";
      this.newsTypeId = "";
      this.newsContent = "";
      this.newsContentReal = "";
      this.newsCover = "";
      this.newsCoverSavePath = "";
      this.newsCoverSrc = "";
      this.newsEdit = false;
      this.noticeEdit = false;
    }

    this.currentPage = page;

    console.log(this.isAdmin)


    if (this.currentPage == "news") {
      this.getNewsType();
    }

    if (this.currentPage == 'trends') {
      this.getTrends();
    }

    if (this.currentPage == 'noticeList') {
      this.getNoticeList(1);
    }

    if (this.currentPage == 'newsList') {
      this.getNewsList(1);
    }

    if (this.currentPage == 'newsType') {
      this.getNewsType()
      this.newsTypeName = "";
      this.newsTypeId = "";
    }

    if (this.currentPage == 'statistic') {
      this.getStatistic(this.statisticCurrentPage);
    }

    if (this.currentPage == 'user') {
      this.getUserList(1)
    }

    // if(page == "question" || page == "onlineTables"){
    //   this.currentPage = "review"
    // }

    if (page == 'review') {
      this.getTableList()
    }

    this.editorInit();
  }

  getTableList() {

    let data = {
      isSearch: this.isSearch,
      pageCurrent: this.pageCurrent,
      hospitalName: this.hospitalName,
      status: this.status
    }

    this.service.getTableList(data).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        if (code == '100000') {

          this.tableList = info['tableList']

          this.pageTotal = info['pageMax'];

          this.pageCurrent = info['pageCurrent'];

          console.log(this.tableList)
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }


  viewDetail(itemInfo, page) {

    console.log(itemInfo)


    let id = itemInfo.organ_id;



    this.hospitalItem = itemInfo['organ'];
    this.inspectTime = itemInfo['update_time'];

    this.userName = itemInfo['self_evaluator_username'];
    this.mobile = itemInfo['other_evaluator_mobile'];
    this.scoreItem = itemInfo['scoreSum'];

    this.checkStatusItem = itemInfo['checkStatus'];
    this.checkStatus = itemInfo['check_status'];

    if (page == 'question') {
      this.scoreItem = itemInfo['selfScoreSum'];
      this.inspectTime = itemInfo['selfUpdateTime'];
    }

    if (page == 'onlineTables') {
      this.scoreItem = itemInfo['otherScoreSum'];
    }

    this.service.getDataDetail(id).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        if (code == '100000') {

          console.log(info)

          let data = info.data;
          let dataTable = info.dataTable;

          console.log(data)

          let score = info.score;
          let scoreTable = info.scoreTable;

          if (JSON.stringify(data) != null && JSON.stringify(data) != '' && JSON.stringify(data) != undefined) {
            this.isUpdate = true;
            this.id = info.id;
            this.idTable = info.idTable;
            this.isExitLast = info.isExitLast;
            this.timeLast = info.time;
            this.scoreLast = info.scoreSumLast;

            let image = info.rowImage;
            let doctor = info.rowDoctor;
            let specialScore = info.specialScore;

            console.log(specialScore)

            this.doctorList = doctor;
            this.img1 = image['img1'];
            this.img2 = image['img2'];
            this.img3 = image['img3'];
            this.img4 = image['img4'];
            this.img5 = image['img5'];
            this.img6 = image['img6'];
            this.img7 = image['img7'];
            this.img8 = image['img8'];
            this.img9 = image['img9'];
            this.img10 = image['img10'];
            this.img11 = image['img11'];
            this.img12 = image['img12'];
            this.img13 = image['img13'];
            this.img14 = image['img14'];
            this.img15 = image['img15'];
            this.img16 = image['img16'];
            this.img17 = image['img17'];
            this.img18 = image['img18'];
            this.img19 = image['img19'];
            this.img20 = image['img20'];

            this.isExitTable = info.isExitLastTable;

            if (page == 'onlineTables') {
              let specialScore = info.scoreTable

              let specialItem = info.dataTable;

              console.log(specialScore)

              this.specialScore1 = specialScore['scoreSpecial1'];
              this.specialScore2 = specialScore['scoreSpecial2'];
              this.specialScore3 = specialScore['scoreSpecial3'];
              this.specialScore4 = specialScore['scoreSpecial4'];
              this.specialScore5 = specialScore['scoreSpecial5'];
              this.specialScore6 = specialScore['scoreSpecial6'];
              this.specialScore7 = specialScore['scoreSpecial7'];



              this.rate1 = specialItem['rate1'];
              this.rate2 = specialItem['rate2'];
              this.rate3 = specialItem['rate3'];
              this.rate4 = specialItem['rate4'];
              this.rate6_1 = specialItem['rate6_1'];
              this.rate6_2 = specialItem['rate6_2'];
              this.rate7 = specialItem['rate7'];

              console.log(this.review)

              // todo: 特殊评分
              this.item1Special = specialItem['item1Special'];
              this.item2Special = specialItem['item2Special'];
              this.item3Special = specialItem['item3Special'];
              this.item4Special = specialItem['item4Special'];

              this.item1SumSpecial = specialItem['item1SumSpecial'];
              this.item2SumSpecial = specialItem['item2SumSpecial'];
              this.item3SumSpecial = specialItem['item3SumSpecial'];
              this.item6_1Special = specialItem['item6_1Special'];
              this.item6_2Special = specialItem['item6_1Special'];
              this.item6_3Special = specialItem['item6_1Special'];
              this.item6_4Special = specialItem['item6_1Special'];
              this.item6_5Special = specialItem['item6_1Special'];
              this.item6_6Special = specialItem['item6_1Special'];
              this.item7Special = specialItem['item7Special'];
              this.itemSumSpecial = specialItem['itemSpecial'];




              this.specialScore = parseInt(specialScore['scoreSpecial']);
            } else if (page == 'question') {
              let specialScore = info.specialScore

              let specialItem = info.special;


              this.specialScore1 = specialScore['score1'];
              this.specialScore2 = specialScore['score2'];
              this.specialScore3 = specialScore['score3'];
              this.specialScore4 = specialScore['score4'];
              this.specialScore5 = specialScore['score5'];
              this.specialScore6 = specialScore['score6'];
              this.specialScore7 = specialScore['score7'];
              this.specialScore = parseInt(specialScore['scoreSum']);


              this.rate1 = specialItem['rate1'];
              this.rate2 = specialItem['rate2'];
              this.rate3 = specialItem['rate3'];
              this.rate4 = specialItem['rate4'];
              this.rate6_1 = specialItem['rate6_1'];
              this.rate6_2 = specialItem['rate6_2'];
              this.rate7 = specialItem['rate7'];

              console.log(this.review)

              // todo: 特殊评分
              this.item1Special = specialItem['item1Special'];
              this.item2Special = specialItem['item2Special'];
              this.item3Special = specialItem['item3Special'];
              this.item4Special = specialItem['item4Special'];

              this.item1SumSpecial = specialItem['item1SumSpecial'];
              this.item2SumSpecial = specialItem['item2SumSpecial'];
              this.item3SumSpecial = specialItem['item3SumSpecial'];
              this.item6_1Special = specialItem['item6_1Special'];
              this.item6_2Special = specialItem['item6_1Special'];
              this.item6_3Special = specialItem['item6_1Special'];
              this.item6_4Special = specialItem['item6_1Special'];
              this.item6_5Special = specialItem['item6_1Special'];
              this.item6_6Special = specialItem['item6_1Special'];
              this.item7Special = specialItem['item7Special'];
              this.itemSumSpecial = specialItem['itemSpecial'];



              // this.specialScore = parseInt(specialScore['scoreSpecial']);
            }


            this.review = {};
            this.scoreMapping = [];

            for (let i = 1; i < 61; i++) {
              let item = "item" + i;

              this.review[item] = "";

            }


            for (let key in data) {
              if (this.review.hasOwnProperty(key)) {
                this.reviewTemp[key] = data[key]
              }

            }

            for (let key in dataTable) {
              if (this.review.hasOwnProperty(key)) {
                this.dataTable[key] = dataTable[key]
              }

            }

            console.log(this.dataTable)


          }

          this.scoreCompute();

          console.log(this.scoreReview)

          if (JSON.stringify(score) != null && JSON.stringify(score) != '' && JSON.stringify(score) != undefined) {
            for (let key in score) {
              if (this.scoreReview.hasOwnProperty(key)) {
                this.scoreReviewTemp[key] = score[key]
              }

            }
          }


          console.log(JSON.stringify(scoreTable))

          if (JSON.stringify(scoreTable) != null && JSON.stringify(scoreTable) != '' && JSON.stringify(scoreTable) != undefined) {
            for (let key in scoreTable) {
              if (this.scoreReview.hasOwnProperty(key)) {
                this.scoreReviewTableTemp[key] = scoreTable[key]
              }

            }
          }

          console.log(this.dataTable);
          console.log(this.scoreReviewTableTemp);

          this.review = {};
          this.scoreMapping = [];

          for (let i = 1; i < 61; i++) {
            let item = "item" + i;

            this.review[item] = "";

          }

          for (let j = 1; j < 61; j++) {
            let item = "item" + j;
            let temp = [];

            temp['item'] = item;
            temp['score'] = "";
            temp['mode'] = "";

            this.scoreMapping.push(temp);
          }

          console.log(this.reviewTemp);
          this.scoreInit();


          if (page == 'onlineTables') {


            this.scoreSum = parseInt(scoreTable.scoreSum) + parseInt(scoreTable.scoreSpecial)

            if (this.isExitTable) {

              console.log(this.dataTable)

              this.review = { ...this.dataTable };
              this.scoreReview = { ...this.scoreReviewTableTemp };

              console.log(this.scoreReview)

              this.scoreReview.scoreSum = parseInt(this.scoreReview.scoreSum)
            }
          }

          if (page == 'question') {
            this.scoreSum = parseInt(score.scoreSum) + parseInt(score.scoreSpecial)
            this.review = { ...this.reviewTemp };

            console.log(this.review)

            this.scoreReview = { ...this.scoreReviewTemp };
            this.scoreReview.scoreSum = parseInt(this.scoreReview.scoreSum)
          }

          this.baseScore = (parseInt(this.scoreReview.scoreSum1) + parseInt(this.scoreReview.scoreSum2) + parseInt(this.scoreReview.scoreSum3) + this.specialScore)

          this.changePage(page)

          console.log(info)


        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  itemChange() {
    return;
  }

  changeItem() {
    return;
  }

  scoreCompute() {

    console.log(this.review)

    let score = 0;

    this.scoreMapping.forEach((val) => {
      switch (val['item']) {
        case "item4":
          if (this.review[val['item']] == '001') {
            val['score'] = '5'
          }
          if (this.review[val['item']] == '002') {
            val['score'] = '4'
          }
          if (this.review[val['item']] == '003') {
            val['score'] = '3'
          }
          break;
        case "item7":
          if (this.review[val['item']] == '001') {
            val['score'] = '5'
          }
          if (this.review[val['item']] == '002') {
            val['score'] = '4'
          }
          if (this.review[val['item']] == '003') {
            val['score'] = '3'
          }
          if (this.review[val['item']] == '004') {
            val['score'] = '1'
          }
          break;

        case "item12":
        case "item13":
        case "item22":
        case "item23":
        case "item36":
          if (this.review[val['item']] == 'on' || this.review[val['item']] == true) {
            val['score'] = '2'
          }
          break;

        case "item14":
        case "item15":
        case "item16":
        case "item17":
        case "item18":
        case "item19":
        case "item20":
        case "item21":
          if (this.review[val['item']] == 'on' || this.review[val['item']] == true) {
            val['score'] = '1'
          }
          break;

        case "item28":
        case "item30":
          if (this.review[val['item']] == '001') {
            val['score'] = '5'
          }
          if (this.review[val['item']] == '002') {
            val['score'] = '3'
          }
          break;

        case "item33":
        case "item34":
        case "item35":
          if (this.review[val['item']] != '' && this.review[val['item']] != null && this.review[val['item']] != undefined) {
            val['score'] = '2'
          }
          break;

        case "item39":
        case "item40":
        case "item42":
        case "item43":
        case "item44":
        case "item46":
        case "item47":
          if (this.review[val['item']] != '' && this.review[val['item']] != null && this.review[val['item']] != undefined) {
            val['score'] = '1'
          }
          break;
      }
    })

    // 
    let list1 = ['item13', 'item14', 'item15', 'item16', 'item17', 'item18', 'item19', 'item20'];

    let list2 = ['item21', 'item22', 'item23'];

    let list3 = ['item49', 'item50', 'item51', 'item52'];

    let list4 = ['item54', 'item55', 'item56'];

    let count1 = 0;
    let count2 = 0;

    let count3 = 0;
    let count4 = 0;

    this.scoreMapping.forEach((val) => {
      if (list1.includes(val['item'])) {
        if (this.review[val['item']] != '' && this.review[val['item']] != null && this.review[val['item']] != undefined) {
          count1 += parseInt(val['score']);
        }
      }

      if (list2.includes(val['item'])) {
        if (this.review[val['item']] != '' && this.review[val['item']] != null && this.review[val['item']] != undefined) {
          count2 += parseInt(val['score']);
        }
      }

      if (list3.includes(val['item'])) {
        if (this.review[val['item']] != '' && this.review[val['item']] != null && this.review[val['item']] != undefined) {
          count3 += parseInt(val['score']);
        }
      }

      if (list4.includes(val['item'])) {
        if (this.review[val['item']] != '' && this.review[val['item']] != null && this.review[val['item']] != undefined) {
          count4 += parseInt(val['score']);
        }
      }
    })

    this.scoreMapping.forEach((value) => {
      if (value['mode'] == 'single') {

        if (!list1.includes(value['item']) && !list2.includes(value['item']) && !list3.includes(value['item']) && !list4.includes(value['item'])) {

          if (this.review[value['item']] == '001' && (value['score'] != "" && value['score'] != undefined && value['score'] != null)) {

            console.log(value['item'])
            score += parseInt(value['score']);
          }
        }

      } else if (value['mode'] == 'checkbox') {
        if (!list1.includes(value['item']) && !list2.includes(value['item']) && !list3.includes(value['item']) && !list4.includes(value['item'])) {


          if ((this.review[value['item']] == true || this.review[value['item']] === "on") && (value['score'] != "" && value['score'] != undefined && value['score'] != null)) {

            console.log(value['item'])
            score += parseInt(value['score']);
          }
        }
      } else {
        if (!list1.includes(value['item']) && !list2.includes(value['item']) && !list3.includes(value['item']) && !list4.includes(value['item'])) {
          if (value['score'] != "" && value['score'] != undefined && value['score'] != null) {
            if (this.review[value['item']] != '' && this.review[value['item']] != null && this.review[value['item']] != undefined) {
              score += parseInt(value['score']);
            }
          }
        }

      }
    })

    if (count1 <= 6) {
      score += count1
    } else {
      score += 6;
    }

    if (count2 >= 1) {
      score += 2;
    }

    if (count3 > 5) {
      score += 5;
    } else {
      score += count3;
    }

    if (count4 > 5) {
      score += 5;
    } else {
      score += count4;
    }



    this.score = score;


    let scoreSum = 0;


    let scoreSum1 = 0;
    let scoreSum2 = 0;
    let scoreSum3 = 0;
    let scoreSum4 = 0;
    let scoreSum5 = 0;
    let scoreSum6 = 0;
    let scoreSum7 = 0;
    let scoreSum8 = 0;
    let scoreSum9 = 0;

    let score1 = 0;
    let score2 = 0;
    let score3 = 0;
    let score4 = 0;
    let score5 = 0;
    let score6 = 0;
    let score7 = 0;
    let score8 = 0;
    let score9 = 0;
    let score10 = 0;
    let score11 = 0;
    let score12 = 0;
    let score13 = 0;
    let score14 = 0;
    let score15 = 0;
    let score16 = 0;
    let score17 = 0;
    let score18 = 0;
    let score19 = 0;
    let score20 = 0;
    let score21 = 0;
    let score22 = 0;
    let score23 = 0;

    console.log(11111)

    this.scoreMapping.forEach((value) => {

      if (value['mode'] == 'single') {

        if (!list1.includes(value['item']) && !list2.includes(value['item'])) {

          if (this.review[value['item']] == '001' && (value['score'] != "" && value['score'] != undefined && value['score'] != null)) {

            if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
              // 基本条件及资质
              if (value['item'] == 'item1') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {

                  console.log(value['score'])

                  score1 = parseInt(value['score']);
                  scoreSum1 = parseInt(value['score']);
                }

              }

              // 组织管理要求
              if (value['item'] == 'item2') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score2 = value['score'];
                  scoreSum2 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item4') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score3 = value['score'];
                  scoreSum2 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item5') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score4 = value['score'];
                  scoreSum2 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item6') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score5 = value['score'];
                  scoreSum2 += parseInt(value['score']);
                }

              }

              // 建设及服务要求
              if (value['item'] == 'item7') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score6 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item8') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score7 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item9') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score8 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item10') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score9 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item11') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score10 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item12' || value['item'] == 'item13' || value['item'] == 'item14' || value['item'] == 'item15' || value['item'] == 'item16' || value['item'] == 'item17' || value['item'] == 'item18' || value['item'] == 'item19' || value['item'] == 'item20' || value['item'] == 'item21' || value['item'] == 'item22' || value['item'] == 'item23') {

                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score11 += parseInt(value['score']);
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item24') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score12 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }

              // 加分项目
              if (value['item'] == 'item25') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score13 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item26') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score14 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item28') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score15 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item30') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score16 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

              }

              if (value['item'] == 'item33') {
                score18 += parseInt(value['score']);
                score17 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
              }
              if (value['item'] == 'item34') {
                score18 += parseInt(value['score']);
                score17 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
              }

              if (value['item'] == 'item35') {
                score18 += parseInt(value['score']);
                score17 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
              }

              if (value['item'] == 'item36') {
                score19 += parseInt(value['score']);
                score17 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
              }

              if (value['item'] == 'item39') {
                score20 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }
              if (value['item'] == 'item40') {
                score20 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }

              if (value['item'] == 'item42') {
                score21 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }
              if (value['item'] == 'item43') {
                score21 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }
              if (value['item'] == 'item44') {
                score21 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }

              if (value['item'] == 'item46') {
                score22 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }
              if (value['item'] == 'item47') {
                score22 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }

              if (value['item'] == 'item49') {
                score22 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum6 += parseInt(value['score']);
              }
              if (value['item'] == 'item50') {
                score22 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum6 += parseInt(value['score']);
              }
              if (value['item'] == 'item51') {
                score22 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum6 += parseInt(value['score']);
              }
              if (value['item'] == 'item52') {
                score22 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum6 += parseInt(value['score']);
              }

              if (value['item'] == 'item54') {
                score23 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum7 += parseInt(value['score']);
              }
              if (value['item'] == 'item55') {
                score23 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum7 += parseInt(value['score']);
              }
              if (value['item'] == 'item56') {
                score23 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum7 += parseInt(value['score']);
              }
            }
          }
        }

      } else if (value['mode'] == 'checkbox') {
        if (!list1.includes(value['item']) && !list2.includes(value['item'])) {


          if ((this.review[value['item']] == true || this.review[value['item']] === "on") && (value['score'] != "" && value['score'] != undefined && value['score'] != null)) {

            if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
              // 基本条件及资质
              if (value['item'] == 'item1') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {

                  console.log(value['score'])

                  score1 = parseInt(value['score']);
                  scoreSum1 = parseInt(value['score']);
                }

              }

              // 组织管理要求
              if (value['item'] == 'item2') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score2 = value['score'];
                  scoreSum2 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item4') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score3 = value['score'];
                  scoreSum2 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item5') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score4 = value['score'];
                  scoreSum2 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item6') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score5 = value['score'];
                  scoreSum2 += parseInt(value['score']);
                }

              }

              // 建设及服务要求
              if (value['item'] == 'item7') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score6 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item8') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score7 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item9') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score8 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item10') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score9 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item11') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score10 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item12' || value['item'] == 'item13' || value['item'] == 'item14' || value['item'] == 'item15' || value['item'] == 'item16' || value['item'] == 'item17' || value['item'] == 'item18' || value['item'] == 'item19' || value['item'] == 'item20' || value['item'] == 'item21' || value['item'] == 'item22' || value['item'] == 'item23') {

                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score11 += parseInt(value['score']);
                  scoreSum3 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item24') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score12 = value['score'];
                  scoreSum3 += parseInt(value['score']);
                }

              }

              // 加分项目
              if (value['item'] == 'item25') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score13 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item26') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score14 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item28') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score15 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

              }
              if (value['item'] == 'item30') {
                if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                  score16 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

              }

              if (value['item'] == 'item33') {
                score18 += parseInt(value['score']);
                score17 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
              }
              if (value['item'] == 'item34') {
                score18 += parseInt(value['score']);
                score17 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
              }

              if (value['item'] == 'item35') {
                score18 += parseInt(value['score']);
                score17 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
              }

              if (value['item'] == 'item36') {
                score19 += parseInt(value['score']);
                score17 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
              }

              if (value['item'] == 'item39') {
                score20 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }
              if (value['item'] == 'item40') {
                score20 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }

              if (value['item'] == 'item42') {
                score21 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }
              if (value['item'] == 'item43') {
                score21 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }
              if (value['item'] == 'item44') {
                score21 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }

              if (value['item'] == 'item46') {
                score22 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }
              if (value['item'] == 'item47') {
                score22 += parseInt(value['score']);
                scoreSum4 += parseInt(value['score']);
                scoreSum5 += parseInt(value['score']);
              }

              if (value['item'] == 'item49') {
                score22 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum6 += parseInt(value['score']);
              }
              if (value['item'] == 'item50') {
                score22 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum6 += parseInt(value['score']);
              }
              if (value['item'] == 'item51') {
                score22 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum6 += parseInt(value['score']);
              }
              if (value['item'] == 'item52') {
                score22 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum6 += parseInt(value['score']);
              }

              if (value['item'] == 'item54') {
                score23 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum7 += parseInt(value['score']);
              }
              if (value['item'] == 'item55') {
                score23 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum7 += parseInt(value['score']);
              }
              if (value['item'] == 'item56') {
                score23 += parseInt(value['score']);
                // scoreSum4 += parseInt(value['score']);
                scoreSum7 += parseInt(value['score']);
              }
            }
          }
        }
      } else {
        if (!list1.includes(value['item']) && !list2.includes(value['item'])) {
          if (value['score'] != "" && value['score'] != undefined && value['score'] != null) {
            if (this.review[value['item']] != '' && this.review[value['item']] != null && this.review[value['item']] != undefined) {
              if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                // 基本条件及资质
                if (value['item'] == 'item1') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {

                    console.log(value['score'])

                    score1 = parseInt(value['score']);
                    scoreSum1 = parseInt(value['score']);
                  }

                }

                // 组织管理要求
                if (value['item'] == 'item2') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score2 = value['score'];
                    scoreSum2 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item4') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score3 = value['score'];
                    scoreSum2 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item5') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score4 = value['score'];
                    scoreSum2 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item6') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score5 = value['score'];
                    scoreSum2 += parseInt(value['score']);
                  }

                }

                // 建设及服务要求
                if (value['item'] == 'item7') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score6 = value['score'];
                    scoreSum3 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item8') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score7 = value['score'];
                    scoreSum3 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item9') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score8 = value['score'];
                    scoreSum3 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item10') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score9 = value['score'];
                    scoreSum3 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item11') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score10 = value['score'];
                    scoreSum3 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item12' || value['item'] == 'item13' || value['item'] == 'item14' || value['item'] == 'item15' || value['item'] == 'item16' || value['item'] == 'item17' || value['item'] == 'item18' || value['item'] == 'item19' || value['item'] == 'item20' || value['item'] == 'item21' || value['item'] == 'item22' || value['item'] == 'item23') {

                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score11 += parseInt(value['score']);
                    scoreSum3 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item24') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score12 = value['score'];
                    scoreSum3 += parseInt(value['score']);
                  }

                }

                // 加分项目
                if (value['item'] == 'item25') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score13 += parseInt(value['score']);
                    scoreSum4 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item26') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score14 += parseInt(value['score']);
                    scoreSum4 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item28') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score15 += parseInt(value['score']);
                    scoreSum4 += parseInt(value['score']);
                  }

                }
                if (value['item'] == 'item30') {
                  if (value['score'] != '' && value['score'] != null && value['score'] != undefined) {
                    score16 += parseInt(value['score']);
                    scoreSum4 += parseInt(value['score']);
                  }

                }

                if (value['item'] == 'item33') {
                  score18 += parseInt(value['score']);
                  score17 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }
                if (value['item'] == 'item34') {
                  score18 += parseInt(value['score']);
                  score17 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

                if (value['item'] == 'item35') {
                  score18 += parseInt(value['score']);
                  score17 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

                if (value['item'] == 'item36') {
                  score19 += parseInt(value['score']);
                  score17 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                }

                if (value['item'] == 'item39') {
                  score20 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                  scoreSum5 += parseInt(value['score']);
                }
                if (value['item'] == 'item40') {
                  score20 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                  scoreSum5 += parseInt(value['score']);
                }

                if (value['item'] == 'item42') {
                  score21 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                  scoreSum5 += parseInt(value['score']);
                }
                if (value['item'] == 'item43') {
                  score21 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                  scoreSum5 += parseInt(value['score']);
                }
                if (value['item'] == 'item44') {
                  score21 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                  scoreSum5 += parseInt(value['score']);
                }

                if (value['item'] == 'item46') {
                  score22 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                  scoreSum5 += parseInt(value['score']);
                }
                if (value['item'] == 'item47') {
                  score22 += parseInt(value['score']);
                  scoreSum4 += parseInt(value['score']);
                  scoreSum5 += parseInt(value['score']);
                }

                if (value['item'] == 'item49') {
                  score22 += parseInt(value['score']);
                  // scoreSum4 += parseInt(value['score']);
                  scoreSum6 += parseInt(value['score']);
                }
                if (value['item'] == 'item50') {
                  score22 += parseInt(value['score']);
                  // scoreSum4 += parseInt(value['score']);
                  scoreSum6 += parseInt(value['score']);
                }
                if (value['item'] == 'item51') {
                  score22 += parseInt(value['score']);
                  // scoreSum4 += parseInt(value['score']);
                  scoreSum6 += parseInt(value['score']);
                }
                if (value['item'] == 'item52') {
                  score22 += parseInt(value['score']);
                  // scoreSum4 += parseInt(value['score']);
                  scoreSum6 += parseInt(value['score']);
                }

                if (value['item'] == 'item54') {
                  score23 += parseInt(value['score']);
                  // scoreSum4 += parseInt(value['score']);
                  scoreSum7 += parseInt(value['score']);
                }
                if (value['item'] == 'item55') {
                  score23 += parseInt(value['score']);
                  // scoreSum4 += parseInt(value['score']);
                  scoreSum7 += parseInt(value['score']);
                }
                if (value['item'] == 'item56') {
                  score23 += parseInt(value['score']);
                  // scoreSum4 += parseInt(value['score']);
                  scoreSum7 += parseInt(value['score']);
                }
              }
            }
          }
        }

      }

    })

    if (count1 <= 6) {
      scoreSum3 += count1
      score11 += count1;
    } else {
      score11 += 6;
      scoreSum3 += 6;
    }

    if (count2 >= 1) {
      score11 += 2;
      scoreSum3 += 2;
    }

    console.log(scoreSum6)
    if (scoreSum6 > 5) {
      scoreSum6 = 5;
      scoreSum4 += 5;
    } else {
      scoreSum4 += scoreSum6;
    }

    if (scoreSum7 > 5) {
      scoreSum7 = 5;
      scoreSum4 += 5;
    } else {
      scoreSum4 += scoreSum7;
    }



    scoreSum = score;


    this.scoreReview = {
      score1: score1,
      score2: score2,
      score3: score3,
      score4: score4,
      score5: score5,
      score6: score6,
      score7: score7,
      score8: score8,
      score9: score9,
      score10: score10,
      score11: score11,
      score12: score12,
      score13: score13,
      score14: score14,
      score15: score15,
      score16: score16,
      score17: score17,
      score18: score18,
      score19: score19,
      score20: score20,
      score21: score21,
      score22: score22,
      score23: score23,
      scoreSum1: scoreSum1,
      scoreSum2: scoreSum2,
      scoreSum3: scoreSum3,
      scoreSum4: scoreSum4,
      scoreSum5: scoreSum5,
      scoreSum6: scoreSum6,
      scoreSum7: scoreSum7,
      scoreSum8: scoreSum8,
      scoreSum9: scoreSum9,
      scoreSum: scoreSum
    }

    console.log(this.scoreReview)
  }

  getUserList(data) {
    this.service.getUserList(data, this.userManagePage).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        if (code == '100000') {
          this.currentPageUser = info['list'];
          this.userPages = info['pages'];
          this.maxPage = info['maxPage'];
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  delete(type) {
    switch (type) {
      case 1:
        this.imgs1.src = "";
        this.imgs1.srcThum = "";
        this.imgs1.savePath = "";
        break;
      case 2:
        this.imgs2.src = "";
        this.imgs2.srcThum = "";
        this.imgs2.savePath = "";
        break;
      case 3:
        this.imgs3.src = "";
        this.imgs3.srcThum = "";
        this.imgs3.savePath = "";
        break;
      case 4:
        this.imgs4.src = "";
        this.imgs4.srcThum = "";
        this.imgs4.savePath = "";
        break;
      case 5:
        this.imgs5.src = "";
        this.imgs5.srcThum = "";
        this.imgs5.savePath = "";
        break;

      case 6:
        this.imgs6.src = "";
        this.imgs6.srcThum = "";
        this.imgs6.savePath = "";
        break;
      case 7:
        this.imgs7.src = "";
        this.imgs7.srcThum = "";
        this.imgs7.savePath = "";
        break;
      case 8:
        this.imgs8.src = "";
        this.imgs8.srcThum = "";
        this.imgs8.savePath = "";
        break;
      case 9:
        this.imgs9.src = "";
        this.imgs9.srcThum = "";
        this.imgs9.savePath = "";
        break;
      case 10:
        this.imgs10.src = "";
        this.imgs10.srcThum = "";
        this.imgs10.savePath = "";
        break;


      case 11:
        this.imgs11.src = "";
        this.imgs11.srcThum = "";
        this.imgs11.savePath = "";
        break;
      case 12:
        this.imgs12.src = "";
        this.imgs12.srcThum = "";
        this.imgs12.savePath = "";
        break;
      case 13:
        this.imgs13.src = "";
        this.imgs13.srcThum = "";
        this.imgs13.savePath = "";
        break;
      case 14:
        this.imgs14.src = "";
        this.imgs14.srcThum = "";
        this.imgs14.savePath = "";
        break;
      case 15:
        this.imgs15.src = "";
        this.imgs15.srcThum = "";
        this.imgs15.savePath = "";
        break;


      case 16:
        this.imgs16.src = "";
        this.imgs16.srcThum = "";
        this.imgs16.savePath = "";
        break;
      case 17:
        this.imgs17.src = "";
        this.imgs17.srcThum = "";
        this.imgs17.savePath = "";
        break;
      case 18:
        this.imgs18.src = "";
        this.imgs18.srcThum = "";
        this.imgs18.savePath = "";
        break;
      case 19:
        this.imgs19.src = "";
        this.imgs19.srcThum = "";
        this.imgs19.savePath = "";
        break;
      case 20:
        this.imgs20.src = "";
        this.imgs20.srcThum = "";
        this.imgs20.savePath = "";
        break;
    }
  }

  imgsChange(files, type) {

    let file = files.target.files.item(0);

    console.log(file)

    this.service.uploadImg(file).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        console.log(info)
        if (code == '100000') {
          switch (type) {
            case 1:
              this.imgs1.src = info['src'];
              this.imgs1.srcThum = info['srcThum'];
              this.imgs1.savePath = info['savePath'];
              break;

            case 2:
              this.imgs2.src = info['src'];
              this.imgs2.srcThum = info['srcThum'];
              this.imgs2.savePath = info['savePath'];
              break;

            case 3:
              this.imgs3.src = info['src'];
              this.imgs3.srcThum = info['srcThum'];
              this.imgs3.savePath = info['savePath'];
              break;

            case 4:
              this.imgs4.src = info['src'];
              this.imgs4.srcThum = info['srcThum'];
              this.imgs4.savePath = info['savePath'];
              break;

            case 5:
              this.imgs5.src = info['src'];
              this.imgs5.srcThum = info['srcThum'];
              this.imgs5.savePath = info['savePath'];
              break;


            case 6:
              this.imgs6.src = info['src'];
              this.imgs6.srcThum = info['srcThum'];
              this.imgs6.savePath = info['savePath'];
              break;

            case 7:
              this.imgs7.src = info['src'];
              this.imgs7.srcThum = info['srcThum'];
              this.imgs7.savePath = info['savePath'];
              break;

            case 8:
              this.imgs8.src = info['src'];
              this.imgs8.srcThum = info['srcThum'];
              this.imgs8.savePath = info['savePath'];
              break;

            case 9:
              this.imgs9.src = info['src'];
              this.imgs9.srcThum = info['srcThum'];
              this.imgs9.savePath = info['savePath'];
              break;

            case 10:
              this.imgs10.src = info['src'];
              this.imgs10.srcThum = info['srcThum'];
              this.imgs10.savePath = info['savePath'];
              break;


            case 11:
              this.imgs11.src = info['src'];
              this.imgs11.srcThum = info['srcThum'];
              this.imgs11.savePath = info['savePath'];
              break;

            case 12:
              this.imgs12.src = info['src'];
              this.imgs12.srcThum = info['srcThum'];
              this.imgs12.savePath = info['savePath'];
              break;

            case 13:
              this.imgs13.src = info['src'];
              this.imgs13.srcThum = info['srcThum'];
              this.imgs13.savePath = info['savePath'];
              break;

            case 14:
              this.imgs14.src = info['src'];
              this.imgs14.srcThum = info['srcThum'];
              this.imgs14.savePath = info['savePath'];
              break;

            case 15:
              this.imgs15.src = info['src'];
              this.imgs15.srcThum = info['srcThum'];
              this.imgs15.savePath = info['savePath'];
              break;


            case 16:
              this.imgs16.src = info['src'];
              this.imgs16.srcThum = info['srcThum'];
              this.imgs16.savePath = info['savePath'];
              break;

            case 17:
              this.imgs17.src = info['src'];
              this.imgs17.srcThum = info['srcThum'];
              this.imgs17.savePath = info['savePath'];
              break;

            case 18:
              this.imgs18.src = info['src'];
              this.imgs18.srcThum = info['srcThum'];
              this.imgs18.savePath = info['savePath'];
              break;

            case 19:
              this.imgs19.src = info['src'];
              this.imgs19.srcThum = info['srcThum'];
              this.imgs19.savePath = info['savePath'];
              break;

            case 20:
              this.imgs20.src = info['src'];
              this.imgs20.srcThum = info['srcThum'];
              this.imgs20.savePath = info['savePath'];
              break;

          }

        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )

    files.target.value = ""

  }

  saveCheck() {
    if ((this.checkStatus == '' || this.checkStatus == null || this.checkStatus == undefined)) {
      this.alertItem1("请选择是否通过");
      return;
    }

    let checkStatus = this.checkStatus;


    this.service.saveCheckStatus(checkStatus, this.idTable).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        console.log(info)
        if (code == '100000') {
          this.alertItem1("审核完成");
          this.changePage('review')
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )

  }


  /**
   * @desc 产品动态上传
   */
  submit() {
    if (this.imgs1.src.length == 0 && this.imgs2.src.length == 0 && this.imgs3.src.length == 0 && this.imgs4.src.length == 0 && this.imgs5.src.length == 0) {
      this.alertItem1("至少选择一张图片");
      return;
    }

    let requestData = [
      {
        number: 1,
        src: this.imgs1.savePath,
        srcThum: this.imgs1.srcThum,
        status: this.imgs1.status,
      },
      {
        number: 2,
        src: this.imgs2.savePath,
        srcThum: this.imgs2.srcThum,
        status: this.imgs2.status,
      },
      {
        number: 3,
        src: this.imgs3.savePath,
        srcThum: this.imgs3.srcThum,
        status: this.imgs3.status,
      },
      {
        number: 4,
        src: this.imgs4.savePath,
        srcThum: this.imgs4.srcThum,
        status: this.imgs4.status,
      },
      {
        number: 5,
        src: this.imgs5.savePath,
        srcThum: this.imgs5.srcThum,
        status: this.imgs5.status,
      },


      {
        number: 6,
        src: this.imgs6.savePath,
        srcThum: this.imgs6.srcThum,
        status: this.imgs6.status,
      },
      {
        number: 7,
        src: this.imgs7.savePath,
        srcThum: this.imgs7.srcThum,
        status: this.imgs7.status,
      },
      {
        number: 8,
        src: this.imgs8.savePath,
        srcThum: this.imgs8.srcThum,
        status: this.imgs8.status,
      },
      {
        number: 9,
        src: this.imgs9.savePath,
        srcThum: this.imgs9.srcThum,
        status: this.imgs9.status,
      },
      {
        number: 10,
        src: this.imgs10.savePath,
        srcThum: this.imgs10.srcThum,
        status: this.imgs10.status,
      },


      {
        number: 11,
        src: this.imgs11.savePath,
        srcThum: this.imgs11.srcThum,
        status: this.imgs11.status,
      },
      {
        number: 12,
        src: this.imgs12.savePath,
        srcThum: this.imgs12.srcThum,
        status: this.imgs12.status,
      },
      {
        number: 13,
        src: this.imgs13.savePath,
        srcThum: this.imgs13.srcThum,
        status: this.imgs13.status,
      },
      {
        number: 14,
        src: this.imgs14.savePath,
        srcThum: this.imgs14.srcThum,
        status: this.imgs14.status,
      },
      {
        number: 15,
        src: this.imgs15.savePath,
        srcThum: this.imgs15.srcThum,
        status: this.imgs15.status,
      },


      {
        number: 16,
        src: this.imgs16.savePath,
        srcThum: this.imgs16.srcThum,
        status: this.imgs16.status,
      },
      {
        number: 17,
        src: this.imgs17.savePath,
        srcThum: this.imgs17.srcThum,
        status: this.imgs17.status,
      },
      {
        number: 18,
        src: this.imgs18.savePath,
        srcThum: this.imgs18.srcThum,
        status: this.imgs18.status,
      },
      {
        number: 19,
        src: this.imgs19.savePath,
        srcThum: this.imgs19.srcThum,
        status: this.imgs19.status,
      },
      {
        number: 20,
        src: this.imgs20.savePath,
        srcThum: this.imgs20.srcThum,
        status: this.imgs20.status,
      },
    ];

    this.service.saveTrends(requestData).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        console.log(info)
        if (code == '100000') {
          this.alertItem1(info);
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  getTrends() {
    this.service.getTrends().subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        if (code == '100000') {
          info.forEach((value) => {
            switch (value['number']) {
              case "1":
                this.imgs1.src = value['src'];
                this.imgs1.srcThum = value['srcThum'];
                this.imgs1.savePath = value['savePath'];
                this.imgs1.status = value['status'];
                break;
              case "2":
                this.imgs2.src = value['src'];
                this.imgs2.srcThum = value['srcThum'];
                this.imgs2.savePath = value['savePath'];
                this.imgs2.status = value['status'];
                break;
              case "3":
                this.imgs3.src = value['src'];
                this.imgs3.srcThum = value['srcThum'];
                this.imgs3.savePath = value['savePath'];
                this.imgs3.status = value['status'];
                break;
              case "4":
                this.imgs4.src = value['src'];
                this.imgs4.srcThum = value['srcThum'];
                this.imgs4.savePath = value['savePath'];
                this.imgs4.status = value['status'];
                break;
              case "5":
                this.imgs5.src = value['src'];
                this.imgs5.srcThum = value['srcThum'];
                this.imgs5.savePath = value['savePath'];
                this.imgs5.status = value['status'];
                break;

              case "6":
                this.imgs6.src = value['src'];
                this.imgs6.srcThum = value['srcThum'];
                this.imgs6.savePath = value['savePath'];
                this.imgs6.status = value['status'];
                break;
              case "7":
                this.imgs7.src = value['src'];
                this.imgs7.srcThum = value['srcThum'];
                this.imgs7.savePath = value['savePath'];
                this.imgs7.status = value['status'];
                break;
              case "8":
                this.imgs8.src = value['src'];
                this.imgs8.srcThum = value['srcThum'];
                this.imgs8.savePath = value['savePath'];
                this.imgs8.status = value['status'];
                break;
              case "9":
                this.imgs9.src = value['src'];
                this.imgs9.srcThum = value['srcThum'];
                this.imgs9.savePath = value['savePath'];
                this.imgs9.status = value['status'];
                break;
              case "10":
                this.imgs10.src = value['src'];
                this.imgs10.srcThum = value['srcThum'];
                this.imgs10.savePath = value['savePath'];
                this.imgs10.status = value['status'];
                break;

              case "11":
                this.imgs11.src = value['src'];
                this.imgs11.srcThum = value['srcThum'];
                this.imgs11.savePath = value['savePath'];
                this.imgs11.status = value['status'];
                break;
              case "12":
                this.imgs12.src = value['src'];
                this.imgs12.srcThum = value['srcThum'];
                this.imgs12.savePath = value['savePath'];
                this.imgs12.status = value['status'];
                break;
              case "13":
                this.imgs13.src = value['src'];
                this.imgs13.srcThum = value['srcThum'];
                this.imgs13.savePath = value['savePath'];
                this.imgs13.status = value['status'];
                break;
              case "14":
                this.imgs14.src = value['src'];
                this.imgs14.srcThum = value['srcThum'];
                this.imgs14.savePath = value['savePath'];
                this.imgs14.status = value['status'];
                break;
              case "15":
                this.imgs15.src = value['src'];
                this.imgs15.srcThum = value['srcThum'];
                this.imgs15.savePath = value['savePath'];
                this.imgs15.status = value['status'];
                break;

              case "16":
                this.imgs16.src = value['src'];
                this.imgs16.srcThum = value['srcThum'];
                this.imgs16.savePath = value['savePath'];
                this.imgs16.status = value['status'];
                break;
              case "17":
                this.imgs17.src = value['src'];
                this.imgs17.srcThum = value['srcThum'];
                this.imgs17.savePath = value['savePath'];
                this.imgs17.status = value['status'];
                break;
              case "18":
                this.imgs18.src = value['src'];
                this.imgs18.srcThum = value['srcThum'];
                this.imgs18.savePath = value['savePath'];
                this.imgs18.status = value['status'];
                break;
              case "19":
                this.imgs19.src = value['src'];
                this.imgs19.srcThum = value['srcThum'];
                this.imgs19.savePath = value['savePath'];
                this.imgs19.status = value['status'];
                break;
              case "20":
                this.imgs20.src = value['src'];
                this.imgs20.srcThum = value['srcThum'];
                this.imgs20.savePath = value['savePath'];
                this.imgs20.status = value['status'];
                break;
            }
          })
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  publish(data, status) {

    data['status'] = status

    // this.service.publish(data, status).subscribe(
    //   data => {
    //     let code = data.resultCode
    //     let info = data.resultInfo

    //     if (code == '100000') {
    //       this.getTrends()
    //     } else {
    //       this.alertItem1(data.resultMsg);
    //       document.getElementById('error').style.display = 'block';
    //     }
    //   }
    // )
  }

  noticeShowHandle() {
    this.showNotice = !this.showNotice
  }


  newsShowHandle() {
    this.showNews = !this.showNews
  }

  // 销毁富文本

  beforeDestroy() {
    this.editor.destroy()
    this.editor = null;
  }



  // 获取通知公告列表
  getNoticeList(page) {
    this.service.getNoticeList(page).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        if (code == '100000') {
          this.currentPageNotice = info['list'];
          this.noticePages = info['pages'];
          this.maxPage = info['maxPage'];
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  getNewsList(page) {
    this.service.getNewsList(page).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        if (code == '100000') {
          this.currentPageNews = info['list'];
          this.newsPages = info['pages'];
          this.maxPage = info['maxPage'];
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  getStatistic(data) {
    this.service.getStatistic(data, this.statisticType).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        if (code == '100000') {
          this.currentPageStatistic = info['list'];
          this.statisticPages = info['pages'];
          this.maxPage = info['maxPage'];
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  changeOperate(type) {
    this.statisticType = type;

    this.getStatistic(this.statisticCurrentPage)
  }

  downLoad(url, fileName) {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.setAttribute('target', '_blank');
    /*
     * download的属性是HTML5新增的属性
     * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
     * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
     * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
     */
    fileName && a.setAttribute('download', fileName);
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  goForward(type) {
    if (type == 'news') {
      if (this.newsCurrentPage >= 2) {
        this.newsCurrentPage -= 1;
        this.getNewsList(this.newsCurrentPage)
      }
    }
    if (type == 'notice') {
      if (this.noticeCurrentPage >= 2) {
        this.noticeCurrentPage -= 1;
        this.getNoticeList(this.noticeCurrentPage)
      }
    }

    if (type == 'statistic') {
      if (this.statisticCurrentPage >= 2) {
        this.statisticCurrentPage -= 1;
        this.getStatistic(this.statisticCurrentPage)
      }
    }

    if (type == 'user') {
      if (this.userCurrentPage >= 2) {
        this.userCurrentPage -= 1;
        this.getUserList(this.userCurrentPage)
      }
    }


  }

  goNext(type) {

    if (type == 'news') {
      if (this.newsCurrentPage < this.maxPage) {
        this.newsCurrentPage += 1;
        this.getNewsList(this.newsCurrentPage)
      }
    }
    if (type == 'notice') {
      if (this.noticeCurrentPage < this.maxPage) {
        this.noticeCurrentPage += 1;
        this.getNoticeList(this.noticeCurrentPage)
      }
    }

    if (type == 'statistic') {
      if (this.statisticCurrentPage < this.maxPage) {
        this.statisticCurrentPage += 1;
        this.getStatistic(this.statisticCurrentPage)
      }
    }


    if (type == 'user') {
      if (this.userCurrentPage < this.maxPage) {
        this.userCurrentPage += 1;
        this.getUserList(this.userCurrentPage)
      }
    }


  }

  edit(data) {

    this.noticeTitle = data['title']
    this.noticeContent = this.sanitizer.bypassSecurityTrustHtml(data['content'])['changingThisBreaksApplicationSecurity'];

    console.log(this.noticeContent)
    this.noticeContentReal = data['content'];
    this.noticeId = data['id'];
    this.noticeEdit = true;


    this.currentPage = "notice"

    var box = document.getElementById('div1');

    if (box != null && this.currentPage == 'notice') {
      box.remove()
      this.editor = null;
    } else {
      this.editorInit();
    }
  }

  editNews(data) {
    this.newsTypeId = data['type'];
    this.newsTitle = data['title'];
    this.newsContent = this.sanitizer.bypassSecurityTrustHtml(data['article']);
    this.newsContentReal = data['article'];
    this.newsId = data['id'];
    this.newsEdit = true;
    this.newsCoverSrc = data['coverSrc'];
    this.newsCoverSavePath = data['cover'];

    this.changePage('news')
  }

  newsTypeChange(data) {
    console.log(this.newsTypeId)
  }

  create() {
    this.noticeTitle = "";
    this.noticeContentReal = "";
    this.noticeContent = "";
    this.noticeEdit = false;
    this.changePage('notice')
  }

  createNews() {
    this.changePage('news')
  }

  save(data) {

    let requestData = [];
    if (data == 'notice') {

      console.log(this.isAdmin)
      if (this.noticeTitle == "") {
        this.alertItem1("请填写通知标题！")
        return;
      }

      if (this.noticeContentReal == "" || this.noticeContentReal == undefined) {
        this.alertItem1("请填写通知内容！")
        return;
      }

      requestData = [
        {
          id: this.noticeId,
          title: this.noticeTitle,
          content: this.noticeContentReal,
          type: this.noticeEdit
        }
      ];
    }

    if (data == 'news') {

      if (this.newsTitle == "") {
        this.alertItem1("请填写文章标题！")
        return;
      }

      if (this.newsContentReal == "") {
        this.alertItem1("请填写文章内容！")
        return;
      }

      if (this.newsTypeId == "") {
        this.alertItem1("请选择文章类型！")
        return;
      }

      requestData = [
        {
          id: this.newsId,
          typeId: this.newsTypeId,
          cover: this.newsCoverSavePath,
          title: this.newsTitle,
          content: this.newsContentReal,
          type: this.newsEdit
        }
      ];
    }

    if (data == "newsType") {
      if (this.newsTypeName == "" || this.newsTypeName.length == 0) {
        this.alertItem1("请填写类型名称！")
        return;
      }

      requestData = [
        {
          id: this.newsTypeId,
          name: this.newsTypeName
        }
      ]
    }

    this.service.save(requestData, data).subscribe(
      datas => {
        let code = datas.resultCode
        let info = datas.resultInfo

        if (code == '100000') {
          if (data == "notice") {
            this.noticeList = info
            this.getNoticeList(1)
            this.currentPage = "noticeList"
          }
          if (data == "news") {
            this.newsList = info
            this.getNewsList(1);
            this.currentPage = "newsList"
          }

          if (data == "newsType") {
            this.getNewsType();
            this.currentPage = "newsType"
          }
          console.log(this.currentPage)
        } else {
          this.alertItem1(datas.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  changeNewsType() {
    console.log(this.newsTypeName)
  }

  changeNoticeTitle() {

  }

  alertItem(msg) {
    const initialState = {
      title: '系统提示',
      content: msg,
      cancelButtonName: "确定",
      confirmButtonShowFlag: false
    };
    this.bsModalRef = this.modalService.show(AlertComponent, { initialState });

    this.modalService.onHidden.subscribe(() => {

      if (this.isAdmin == false) {
        this.router.navigateByUrl('home')

        console.log(222222)
      }

    });
    this.bsModalRef.content.onClose = (msg: string) => {

      if (this.isAdmin == false) {

        console.log(11111111)
        this.router.navigateByUrl('home')
      }
    }
  }


  alertItem1(msg) {
    const initialState = {
      title: '系统提示',
      content: msg,
      cancelButtonName: "确定",
      confirmButtonShowFlag: false
    };
    this.bsModalRef = this.modalService.show(AlertComponent, { initialState });

    this.modalService.onHidden.subscribe(() => {

    });
    this.bsModalRef.content.onClose = (msg: string) => {

      console.log(1111)


    }
  }

  banItem1(msg, id, type) {
    const initialState = {
      title: '系统提示',
      content: msg,
      cancelButtonName: "取消",
      confirmButtonShowFlag: true
    };

    if (type == 2) {
      this.bsModalRef = this.modalService.show(InputAlertComponent, { initialState });
    } else {
      this.bsModalRef = this.modalService.show(AlertComponent, { initialState });
    }

    this.modalService.onHidden.subscribe(() => {

    });
    this.bsModalRef.content.onClose = (msg: string, data) => {

      console.log(data)
      if (msg == "confirm") {
        this.userHandle(id, type, data)
      }
    }
  }

  userHandle(id, type, reason) {
    this.service.userHandle(id, type, reason).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        console.log(info)
        if (code == '100000') {

          this.getUserList(this.userCurrentPage)
          this.alertItem1("处理完成")
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  newsImgsChange(files) {
    let file = files.target.files.item(0);

    console.log(file)

    this.service.uploadImg(file).subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        console.log(info)
        if (code == '100000') {
          this.newsCoverSrc = info['src']
          this.newsCoverSavePath = info['savePath']
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  deleteNewsImg() {
    this.newsCoverSavePath = "";
    this.newsCoverSrc = "";
  }


  getNewsType() {
    this.service.getNewsType().subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        console.log(info)
        if (code == '100000') {
          this.newsTypeList = info;
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }

  editNewsType(data) {

    this.newsTypeId = data['id'];
    this.newsTypeName = data['name'];

    this.currentPage = "newsTypeEdit"
  }

  deleteNotice(data) {
    const initialState = {
      title: '系统提示',
      content: "确定要删除吗",
      cancelButtonName: "取消",
      confirmButtonShowFlag: true
    };
    this.bsModalRef = this.modalService.show(AlertComponent, { initialState });

    this.modalService.onHidden.subscribe((data) => {
      console.log(data)
    });
    this.bsModalRef.content.onClose = (msg: string) => {
      console.log(11111)
      this.service.deleteNotice(data['id']).subscribe(
        data => {
          let code = data.resultCode
          let info = data.resultInfo

          console.log(info)
          if (code == '100000') {
            this.getNoticeList(1)
          } else {
            this.alertItem1(data.resultMsg);
            document.getElementById('error').style.display = 'block';
          }
        }
      )
    }
  }

  deleteNews(data) {
    const initialState = {
      title: '系统提示',
      content: "确定要删除吗",
      cancelButtonName: "取消",
      confirmButtonShowFlag: true
    };
    this.bsModalRef = this.modalService.show(AlertComponent, { initialState });

    this.modalService.onHidden.subscribe((data) => {
      console.log(data)
    });
    this.bsModalRef.content.onClose = (msg: string) => {
      console.log(11111)
      this.service.deleteNews(data['id']).subscribe(
        data => {
          let code = data.resultCode
          let info = data.resultInfo

          console.log(info)
          if (code == '100000') {
            this.getNewsList(1)
          } else {
            this.alertItem1(data.resultMsg);
            document.getElementById('error').style.display = 'block';
          }
        }
      )
    }
  }


  deleteNewsType(data) {
    const initialState = {
      title: '系统提示',
      content: "确定要删除吗",
      cancelButtonName: "取消",
      confirmButtonShowFlag: true
    };
    this.bsModalRef = this.modalService.show(AlertComponent, { initialState });

    this.modalService.onHidden.subscribe((data) => {
      console.log(data)
    });
    this.bsModalRef.content.onClose = (msg: string) => {
      console.log(11111)
      this.service.deleteNewsType(data['id']).subscribe(
        data => {
          let code = data.resultCode
          let info = data.resultInfo

          console.log(info)
          if (code == '100000') {
            this.getNewsType()
          } else {
            this.alertItem1(data.resultMsg);
            document.getElementById('error').style.display = 'block';
          }
        }
      )
    }
  }

  createNewsType() {
    this.currentPage = "newsTypeEdit"
    this.newsTypeName = "";
    this.newsTypeId = "";

    console.log(this.isAdmin)
    this.getNewsType();
  }

  logout() {
    this.service.logout().subscribe(
      data => {
        let code = data.resultCode
        let info = data.resultInfo

        if (code == '100000') {
          this.router.navigateByUrl("home");
        } else {
          this.alertItem1(data.resultMsg);
          document.getElementById('error').style.display = 'block';
        }
      }
    )
  }
  // 放大图片
  bigImgShow(src) {
    this.bigImgSrc = src;
    this.bigImg = true
  }
  bigImgHide() {
    this.bigImg = false
  }

}
